import styles from './OfficeAppsSidebar.module.css'

const OFFICE_APPS = [
  {
    id: 'outlook',
    label: 'Outlook',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/Mail_22px-hash-ef494f7f.m.svg',
  },
  {
    id: 'calendar',
    label: 'Calendar',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/Calendar_22px-hash-4b5e2360.m.svg',
  },
  {
    id: 'onedrive',
    label: 'OneDrive',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/onedrive_24x-hash-e0d279de.m.svg',
  },
  {
    id: 'people',
    label: 'People',
    icon: 'https://res.public.onecdn.static.microsoft/owamail/hashed-v1/resources/images/People_22px-hash-6b8f0c5c.m.svg',
  },
]

export function OfficeAppsSidebar() {
  return (
    <aside className={styles.appsSidebar}>
      <nav className={styles.appsNav}>
        {OFFICE_APPS.map((app) => (
          <button key={app.id} className={styles.appButton} title={app.label}>
            <img src={app.icon} alt={app.label} className={styles.appIcon} />
          </button>
        ))}
      </nav>
    </aside>
  )
}
